// Lightweight analytics wrapper. Pushes to window.dataLayer (GTM) and gtag if
// present. Safe no-op when no analytics tool is configured — no credentials
// required to launch.
export function track(event, params = {}) {
  try {
    if (window.dataLayer) {
      window.dataLayer.push({ event, ...params });
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch {
    /* analytics must never break the app */
  }
}
